import styled, { css } from "styled-components";
import AntInput from "antd/es/input";
import { getNewLookPlaceholderColor } from "common/Inputs/styles";

/**
 * New look: with a count or a clear icon the text area sits inside a rounded
 * field wrapper. The text area stays transparent and follows the wrapper's
 * radius (so its corners don't paint over the wrapper's border), and in
 * outlined fields the count sits inside the field's bottom corner instead of
 * hanging below it over whatever follows. Written for both the component
 * (the wrapper is the root) and the app-wide copy of these styles.
 */
const newLookTextAreaStyles = css`
  &.ant-input-textarea-affix-wrapper > textarea.ant-input,
  .ant-input-textarea-affix-wrapper > textarea.ant-input {
    border-radius: inherit;
    background: transparent !important;
  }
  &.ant-input-textarea-show-count.ant-input-outlined > textarea.ant-input,
  .ant-input-textarea-show-count.ant-input-outlined > textarea.ant-input {
    padding-bottom: 28px;
  }
  &.ant-input-textarea-show-count.ant-input-outlined .ant-input-data-count,
  .ant-input-textarea-show-count.ant-input-outlined .ant-input-data-count {
    bottom: 6px;
    inset-inline-end: 12px;
    color: ${(p) => p.theme.colors.secondaryText};
    font-size: 12px;
    line-height: 18px;
    font-variant-numeric: tabular-nums;
  }
`;

export const textAreaStyles = css`
  .ant-input {
    color: ${(p) => p.theme.colors.textColor};
    background: ${(p) => p.theme.colors.cardBgColor} !important;
    color: ${(p) => p.theme.colors.primaryGrey};
    border-color: ${(p) => p.theme.colors.lightBorderGrey};
  }

  color: ${(p) => p.theme.colors.textColor};

  .ant-input-textarea:after {
    color: ${(p) => p.theme.colors.secondaryGrey};
  }

  .ant-input-clear-icon,
  .anticon.ant-input-clear-icon {
    color: ${(p) => p.theme.colors.secondaryGrey};
  }

  ${(p) =>
    !p.theme.isNewLook &&
    css`
      &.ant-input-affix-wrapper:focus-within {
        box-shadow: none !important;
      }
    `}

  ${(p) => p.theme.isNewLook && newLookTextAreaStyles};

  ::placeholder {
    color: ${(p) =>
      p.theme.isNewLook
        ? getNewLookPlaceholderColor(p.theme)
        : p.theme.colors.lightestGrey};
  }
`;

const TextArea = styled(AntInput.TextArea)`
  ${textAreaStyles};
`;

export default TextArea;
